export const MESSAGING_TEMPLATE_PIN_REQUIRED_VARIABLE_NAME = "pincode";
export const MESSAGING_TEMPLATE_DCUI_REQUIRED_VARIABLE_NAME = "dcuiUrl";
export const MESSAGING_TEMPLATE_PIN_EMAIL_SUBJECT_VARIABLE_NAME = "emailpin.subject";
export const MESSAGING_TEMPLATE_DCUI_EMAIL_SUBJECT_VARIABLE_NAME = "dcuiEmail.subject";
export const MESSAGING_TEMPLATE_HEADER_LOGO_VARIABLE_NAME = "headerlogo";

export const REQUIRED_MESSAGING_TEMPLATE_VARIABLES = [
    MESSAGING_TEMPLATE_DCUI_REQUIRED_VARIABLE_NAME,
    MESSAGING_TEMPLATE_PIN_REQUIRED_VARIABLE_NAME,
    MESSAGING_TEMPLATE_DCUI_EMAIL_SUBJECT_VARIABLE_NAME,
    MESSAGING_TEMPLATE_PIN_EMAIL_SUBJECT_VARIABLE_NAME
];

export const MESSAGING_TEMPLATE_DCUI_REQUIRED_VARIABLE = `\${(${MESSAGING_TEMPLATE_DCUI_REQUIRED_VARIABLE_NAME})!"URL_ERROR"}`;
export const MESSAGING_TEMPLATE_DCUI_SMS_DEFAULT = `\${(dcuiSMS.clickUrl)!"Click the URL below to capture documents"} : ${MESSAGING_TEMPLATE_DCUI_REQUIRED_VARIABLE}`;
export const MESSAGING_TEMPLATE_DCUI_EMAIL_DEFAULT = `<html>
    <body>
        <p>\${(dcuiSMS.clickUrl)!"Click the URL below to capture documents"}</p>
        <br/>
        ${MESSAGING_TEMPLATE_DCUI_REQUIRED_VARIABLE}
        <br>
        <hr>
        ID Dataweb INC
    </body>
</html>`;

export const MESSAGING_TEMPLATE_PIN_REQUIRED_VARIABLE = `\${(${MESSAGING_TEMPLATE_PIN_REQUIRED_VARIABLE_NAME})!"PIN_ERROR"}`;
export const MESSAGING_TEMPLATE_PIN_EMAIL_DEFAULT = `<html>
    <body>
        <p>\${(emailpin.yourCodeIs)!"Below is the verification code needed to confirm your email address:"}</p>
        <br/>
        <p>
            <h3 style="color:Darkblue">${MESSAGING_TEMPLATE_PIN_REQUIRED_VARIABLE}</h3>
        </p>
        <br>
        <p>\${(emailpin.contactInfo)!"If you did not request a verification code, or have received this message in error, please contact your administrator."}</p>
        <hr>
        ID Dataweb INC
    </body>
</html>`;
export const MESSAGING_TEMPLATE_PIN_SMS_DEFAULT = `\${(smspin.yourCodeIs)!"Your Application validation code is:"} ${MESSAGING_TEMPLATE_PIN_REQUIRED_VARIABLE}`;